// import React, {useEffect, useMemo, useRef, useState} from 'react';
import { getApp } from 'firebase/app';
import { buildTreeFromShallowItems, shallowFlattenTree } from './Tree/utilities.ts';
// import { v4 as uuid } from 'uuid';
// import { TreeItem, TreeItems } from './Tree/types.ts';
import { doc, getFirestore, collection, onSnapshot, query, orderBy, setDoc, getDocs, writeBatch, getDocsFromServer, where } from "firebase/firestore";
import { getAuth } from 'firebase/auth';

// const analytics = getAnalytics(app);

// const db = getFirestore(app);
// console.log(db);

// try {
//   const docRef = await addDoc(collection(db, "projects"), {
//     name: "TAOIS Projects",
//     createdAt: new Date(),
//     });
//   console.log("Document written with ID: ", docRef.id);
// } catch (e) {
//   console.error("Error adding document: ", e);
// }

async function loadItemsFromFirebase(db, setItems) {

  // Helper function to safely extract ISO string if timestamp exists
  const convertToIso = (timestampField) => {
    return timestampField && typeof timestampField.toDate === 'function'
      ? timestampField.toDate().toISOString()
      : timestampField;
  };

  //TODO: Much to fix/revise/refactor here...
  const isoConverter = {
  toFirestore: (data) => data, // Pass through when writing
  fromFirestore: (snapshot, options) => {
    const data = snapshot.data(options);
    return {
      id: data.id ?? undefined,
      ...(('title' in data) && {title: data.title ?? ""}),
      ...(('ownerId' in data) && {ownerId: data.ownerId}),
      ...(('creationDate' in data) && {creationDate: convertToIso(data.creationDate)}),
      ...(('desc' in data) && {desc: data.desc}),
      children: data.children,
      childrenIds: data.childrenIds,
      ...(('goal' in data) && {goal: data.goal}),
      ...(('status' in data) && {status: data.status}),
      ...(('primaryLabel' in data) && {primaryLabel: data.primaryLabel}),
      parentId: data.parentId ?? null,
      ...(('depth' in data) && {depth: data.depth}),
      ...(('index' in data) && {index: data.index}),
      ...(('collapsed' in data) && {collapsed: data.collapsed}),
      ...(('estimatedCommencementDate' in data) && {estimatedCommencementDate: convertToIso(data.estimatedCommencementDate ?? null)}),
      ...(('idealCompletionDate' in data) && {idealCompletionDate: convertToIso(data.idealCompletionDate ?? null)}),
      ...(('latestPossibleCompletionDate' in data) && {latestPossibleCompletionDate: convertToIso(data.latestPossibleCompletionDate ?? null)}),
      ...(('start' in data) && {start: convertToIso(data.start ?? null)}),
      ...(('end' in data) && {end: convertToIso(data.end ?? null)}),
      ...(('allDay' in data) && {allDay: data.allDay}),
      ...(('done' in data) && {done: data.done})
      };
    }
  };

// Use with your collection reference
// const colRef = collection(db, "users").withConverter(isoConverter);

  const currentUserUid = getAuth().currentUser?.uid;

  if(currentUserUid) {

    const userDocumentsQuery = query(
      collection(db, "tasks").withConverter(isoConverter), 
      where("ownerId", "==", currentUserUid),
      orderBy("index")
    );

    const querySnapshot = await getDocsFromServer(userDocumentsQuery);

    setItems( buildTreeFromShallowItems( querySnapshot.docs.map( doc => (doc.data())) ) );

  }
}

async function deleteItemsFromFirebaseInBatch(db, batch) {
    const q = query(collection(db, "tasks"), orderBy("index"));
    const querySnapshot = await getDocs(q);
    // querySnapshot.docs.forEach( doc => { batch.delete(doc) });
    for (const doc of querySnapshot.docs) {
      batch.delete(doc);
    }
}

async function setTaskInBatch(db, batch, task) {

  // if(taskDocRef) {
    try {

      const taskDocRef = await doc(db, "tasks", task.id);

      console.log("What task ref is returned??: ", taskDocRef);

      //TODO:: Do an ungodly number of (nested) try/catch statements here
      //TODO:: Change this to a batchWrite or transaction
      // const updatedDocRef = await setDoc(taskDocRef, task);
      // const setDocRef = await setDoc(db, task);
      batch.set(taskDocRef, task);

      // console.log("Document written with ID: ", updatedDocRef.id);
      // console.log("Document set with ID: ", setDocRef);
    } catch (e) {
      console.error("Error updating tasks: ", e);
      // try {

      //   // const updatedDocRef = await updateDoc(taskDocRef, task);

      //   const docRef = await addDoc(collection(db, "tasks"), task);

      //   console.log("Document written with ID: ", docRef.id);
      // } catch (e) {
      //   console.error("Error adding document: ", e);
      // }
    }

  // }
  // else {
    // try {

    //   // const updatedDocRef = await updateDoc(taskDocRef, task);

    //   const docRef = await addDoc(collection(db, "tasks"), task);

    //   console.log("Document written with ID: ", docRef.id);
    // } catch (e) {
    //   console.error("Error adding document: ", e);
    // }

  // }  

}

async function commitBatch(batch) {
    try {
      // Execution pauses here until the batch is fully committed
      await batch.commit(); 
      console.log("All writes succeeded!");
    } 
    catch (error) {
      console.error("Batch failed: ", error);
    }

    return;
}

async function handleSaveClick(e, items, firebaseApp) { 
        
    e.preventDefault();

    console.log('Doing cloud save stuff...');

    const currentUserId = getAuth().currentUser?.uid;

    const db = getFirestore(firebaseApp);
    console.log(db);

    const batch = writeBatch(db);

    // const q = query(collection(db, "tasks"), orderBy("index"));
    // const querySnapshot = await getDocs(q);
    // querySnapshot.docs.forEach( doc => { batch.delete(doc) });
    // await deleteItemsFromFirebaseInBatch(db, batch);
    const q = query( collection(db, "tasks"),
                     where("ownerId", "==", currentUserId) );

    const querySnapshot = await getDocs(q);

    // querySnapshot.docs.forEach( doc => { batch.delete(doc) });
    for (const doc of querySnapshot.docs) {
      console.log("Adding 'delete' operation to batch delete for doc: " + doc.ref);
      batch.delete(doc.ref);
    }
    // setItems(buildTree( querySnapshot.docs.map(doc => (doc.data()))
    // ));

    // // flattenTree(items).forEach( (item) => { setTaskInBatch(db, batch, item) } );
    for (const task of shallowFlattenTree(items)) {
      // await setTaskInBatch(db, batch, item);
      try {

        const taskDocRef = await doc(db, "tasks", task.id);

        console.log("What task ref is returned??: ", taskDocRef);

        task.ownerId = currentUserId;

        // const updatedDocRef = await setDoc(taskDocRef, task);
        // const setDocRef = await setDoc(db, task);
        batch.set(taskDocRef, task);

        // console.log("Document written with ID: ", updatedDocRef.id);
        // console.log("Document set with ID: ", setDocRef);
      } 
      catch (e) {
       console.error("Error updating tasks: ", e);
      // try {

      //   // const updatedDocRef = await updateDoc(taskDocRef, task);

      //   const docRef = await addDoc(collection(db, "tasks"), task);

      //   console.log("Document written with ID: ", docRef.id);
      // } catch (e) {
      //   console.error("Error adding document: ", e);
      // }
      }
    }

    
    //   const cumulativeItemCount = parseInt(localStorage.getItem("itemCount"));
    //   console.log('Cumulative item count as parsed: '+cumulativeItemCount);
    
    //   if(items) {
    //     console.log(JSON.stringify(items, null, 2));

    //     function downloadTextFile(text, name) {
    //       const a = document.createElement('a');
    //       const type = name.split(".").pop();
    //       a.href = URL.createObjectURL( new Blob([text], { type:`text/${type === "txt" ? "plain" : type}` }) );
    //       a.download = name;
    //       a.click();
    //     }
    //     const dataString = JSON.stringify(items, null, 2); 
    //     downloadTextFile(cumulativeItemCount+'\n'+dataString, 'My TAOIS data.json');
    // }

    // commitBatch(batch);
    await batch.commit();

    // for (const task of flattenTree(items)) {
    //   // await setTaskInBatch(db, batch, item);

    //     const taskDocRef = await doc(db, "tasks", task.id);

    //     console.log("What task ref is returned??: ", taskDocRef);

    //   try {



    //     // const updatedDocRef = await setDoc(taskDocRef, task);
    //     const setDocRef = await setDoc(taskDocRef, task);

    //     // console.log("Document written with ID: ", updatedDocRef.id);
    //     // console.log("Document set with ID: ", setDocRef);
    //   } 
    //   catch (e) {
    //     console.error("Error updating tasks: "+task.title + " - "+ task.id, e);
    //   // try {

    //   //   // const updatedDocRef = await updateDoc(taskDocRef, task);

    //   //   const docRef = await addDoc(collection(db, "tasks"), task);

    //   //   console.log("Document written with ID: ", docRef.id);
    //   // } catch (e) {
    //   //   console.error("Error adding document: ", e);
    //   // }
    //   }
    // }

  }

function CloudDataPanel(  {items, setItems, firebaseApp}  ) {

  const db = getFirestore(firebaseApp);
  console.log(db);

    // const [inputStartText, setInputStartText] = useState('');

    function handleLoadClick(e) { 
      
      e.preventDefault();
  
      // Read the form data
      // const form = e.target;
      // const formData = new FormData(form);

      // Or you can work with it as a plain object:
      // const formJson = Object.fromEntries(formData.entries());
      console.log('Doing cloud load stuff...');
      
      loadItemsFromFirebase(db, setItems);
      
      // let cumulativeItemCountString;
      // console.log('Cumulative item count as parsed: '+cumulativeItemCount);
      // if(isNaN(cumulativeItemCount))
      // {
      //   cumulativeItemCountString = "0";
      // }
      // else {
      //   cumulativeItemCountString = cumulativeItemCount;
      // }
      // const newItem = [{id: "Task #"+cumulativeItemCountString+" : "+formJson.taskTitle, children: []}];
      // setInputStartText('');



      //TODO: Load and parse in  file.

      // TODO: Will need to set item counter if importing and a counter is found
      //localStorage.setItem("itemCount", cumulativeItemCountString+1);

      // if(items) {
        //TODO: Set items from file if importing.
        // const newItems = newItem.concat(items);
        // setItems(newItems);
      
        // const dbOpenRequest = window.indexedDB.open("TasksDB",1);

        // let db;

        // let objectStore;

        // dbOpenRequest.onerror = (event) => {
        //   console.error(`Database error: ${event.target.error?.message}`);
        //   alert("Issue connecting to DB!!");
        // };

        // dbOpenRequest.onsuccess = (event) => {
        //   db = event.target.result;
        //   console.log('DB connection opened for updating!!');

        // // This assumes the objectStore has already been successfully created in the DB
        // // TODO: handle the exception if not.
        // const objectStore = db
        //   .transaction("TaskNestedLists", "readwrite")
        //   .objectStore("TaskNestedLists");
          
        //   console.log('Got object store on button clicked!! '+ objectStore);
        //   const storedItems = event.target.result;
        //   console.log('Items obtained from DB: '+storedItems);
        //   const requestUpdate = objectStore.put(newItems,1);
        //   requestUpdate.onsuccess = (event) => {
        //     // Success - the data is updated!
        //   };

        // };

        // dbOpenRequest.onupgradeneeded = (event) => {
        //   db = event.target.result;
        //   alert("DB was upgraded!!");  
          
        //   const objectStore = db
        //   .transaction("TaskNestedLists", "readwrite")
        //   .objectStore("TaskNestedLists");

        //   objectStore.put(newItems, 1);

        // };

    // }

    // var input = document.createElement('input');
    // input.type = 'file';

    // input.onchange = e => { 

    //   // getting a hold of the file reference
    //   var file = e.target.files[0]; 

    //   // setting up the reader
    //   var reader = new FileReader();
    //   reader.readAsText(file,'UTF-8');

    //   // here we tell the reader what to do when it's done reading...
    //   reader.onload = readerEvent => {
    //       var content = readerEvent.target.result; // this is the content!
    //       console.log( content );
    //       const cumulativeItemCount = parseInt(content.split('\n')[0]);
    //       console.log('Cumulative item count as parsed from file: '+cumulativeItemCount);

    //       //TODO All kinds of null checks needed here!!!
    //       if(cumulativeItemCount &&(cumulativeItemCount > parseInt(localStorage.getItem("itemCount")))) {
    //         console.log('Setting local storage Cumulative item count to: '+cumulativeItemCount);
    //         localStorage.setItem("itemCount", cumulativeItemCount);
    //       }
          
    //       var loadedItems = JSON.parse(content.split('\n').slice(1).join('\n'), reviver);
    //       console.log( loadedItems);

    //       //TODO: This is effective in ensuring valid data but quite inefficient...
    //       setItems(buildTree(flattenTree(enforceUUIDs(loadedItems))));
    //   }
    // }
    
  }

  return (
    <>
      <form padding="25xp" method="post" onSubmit={handleLoadClick}>
        <button type="submit">Load Cloud Data</button>
      </form>
      <form padding="25xp" method="post" onSubmit={(e)=>handleSaveClick(e, items, firebaseApp)}>
        <button type="submit">Save Data to Cloud</button>
      </form>
    </>
    
  );

}

export default CloudDataPanel;